import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

import { registerControllers } from 'stimulus-vite-helpers';

const controllers = import.meta.glob('./**/*_controller.*', { eager: true });
registerControllers(application, controllers);

// controllers of engines in core/engines/, same identifiers (admin/foo_bar_controller.js -> "admin--foo-bar")
const engineControllers = import.meta.glob(
  '../../../engines/*/app/javascript/controllers/**/*_controller.*',
  { eager: true }
);
registerControllers(application, engineControllers);

import { Tabs } from 'tailwindcss-stimulus-components';
application.register('tabs', Tabs);

import PasswordVisibility from '@stimulus-components/password-visibility';
application.register('password-visibility', PasswordVisibility);

import Clipboard from '@stimulus-components/clipboard';
application.register('clipboard', Clipboard);
